import classNames from 'classnames';
import React from 'react';

interface ICardIconProps {
	color: 'yellow' | 'red';
}
interface IPenaltyIconProps {
	color: 'green' | 'red';
}
interface IMatchTimelineProps {
	homeId: string;
	awayId: string;
	combinedEvents: any[];
}

const PenaltyIcon = ({ color }: IPenaltyIconProps) => {
	const commonClasses = 'h-8 w-8 rounded-full flex items-center justify-center';

	const colorClass = color === 'red' ? 'bg-red-500' : 'bg-green-500';

	return (
		<span className={classNames(commonClasses, colorClass)}>
			<svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" className="-ml-[1px] -mt-[3px]">
				<defs>
					<clipPath id="a">
						<path
							data-name="Rectangle 267"
							fill="none"
							stroke="#fff"
							strokeWidth="2"
							d="M17687 714h19v17h-19z"
						/>
					</clipPath>
				</defs>
				<g data-name="Group 230">
					<g data-name="Mask Group 1" transform="translate(-17687 -714)" clip-path="url(#a)">
						<g data-name="Rectangle 268" fill="none" stroke="#fff" strokeWidth="2">
							<path d="M17691 718h12a2 2 0 0 1 2 2v15h-16v-15a2 2 0 0 1 2-2Z" stroke="none" />
							<path d="M17691 719h12a1 1 0 0 1 1 1v14h-14v-14a1 1 0 0 1 1-1Z" />
						</g>
					</g>
					<path
						data-name="image (3)"
						d="M13.685 12.843A3.843 3.843 0 1 1 9.843 9a3.841 3.841 0 0 1 3.842 3.843Zm-.745 0-.4.349-.97-.906.255-1.306.532.047a3.076 3.076 0 0 0-1.565-1.133l.213.494-1.162.642-1.162-.643.213-.494a3.118 3.118 0 0 0-1.562 1.133l.536-.047.251 1.306-.97.906-.4-.353a3.079 3.079 0 0 0 .6 1.834l.119-.523 1.319.162.562 1.2-.464.277a3.122 3.122 0 0 0 1.932 0l-.464-.277.562-1.2 1.319-.162.119.523a3.076 3.076 0 0 0 .6-1.83Zm-3.842 1.076-.464-1.412 1.209-.877 1.209.877-.46 1.413Z"
						fill="#fff"
					/>
				</g>
			</svg>
		</span>
	);
};

const GoalIcon = ({ color }: ICardIconProps) => (
	<span
		className={classNames(
			'h-8 w-8 rounded-full flex items-center justify-center',
			color === 'red' ? 'bg-red-500' : 'bg-green-500',
		)}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			fill="#ffffff"
			className="w-5 h-5"
		>
			<path d="m20.65,12.03c0,4.99-4.04,9.03-9.03,9.03S2.59,17.02,2.59,12.03,6.63,3,11.62,3s9.03,4.04,9.03,9.03Zm-1.75,0h0s-.95.82-.95.82l-2.28-2.13.6-3.07,1.25.11c-.91-1.25-2.18-2.19-3.67-2.66l.5,1.16-2.73,1.51-2.73-1.51.5-1.16c-1.48.47-2.76,1.42-3.67,2.66l1.26-.11.59,3.07-2.28,2.13-.95-.83h0c0,1.58.49,3.07,1.4,4.31l.28-1.23,3.1.38,1.32,2.83-1.09.65c1.46.48,3.07.48,4.54,0l-1.09-.65,1.32-2.83,3.1-.38.28,1.23c.91-1.24,1.4-2.73,1.4-4.3Zm-9.03,2.53l-1.09-3.32,2.84-2.06,2.84,2.06-1.08,3.32h-3.51Z" />
		</svg>
	</span>
);

const SubstituteIcon = () => (
	<span className={'h-8 w-8 rounded-full flex items-center justify-center bg-gray-500'}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			fill="#323232"
			className="w-5 h-5"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="m12,20.17c-1.19,0-2.38-.04-3.56-.13-2.36-.17-4.27-2.09-4.45-4.45l-.05-.59c-.02-.22-.03-.41-.04-.6l-1.19,1.19c-.39.39-1.02.39-1.41,0s-.39-1.02,0-1.41l2.86-2.86c.39-.39,1.02-.39,1.41,0l2.86,2.86c.39.39.39,1.02,0,1.41s-1.02.39-1.41,0l-1.1-1.1c0,.11.02.22.03.34l.05.6c.1,1.38,1.22,2.5,2.6,2.6,2.26.17,4.56.17,6.83,0,1.38-.1,2.5-1.22,2.6-2.6l.04-.62c.04-.55.49-.96,1.06-.93.55.04.97.51.93,1.06l-.04.64c-.17,2.36-2.09,4.27-4.45,4.45-1.18.09-2.37.13-3.56.13Zm7.14-7.14c-.26,0-.51-.1-.71-.29,0,0,0,0,0,0l-2.85-2.85c-.39-.39-.39-1.02,0-1.41.39-.39,1.02-.39,1.41,0l1.1,1.1c0-.11-.02-.23-.03-.37l-.05-.58c-.1-1.38-1.22-2.5-2.6-2.6-2.27-.17-4.56-.17-6.83,0-1.38.1-2.5,1.22-2.6,2.6l-.04.62c-.04.55-.52.97-1.06.93-.55-.04-.97-.51-.93-1.06l.04-.64c.17-2.36,2.09-4.27,4.45-4.45,2.36-.18,4.76-.18,7.12,0,2.36.17,4.27,2.09,4.45,4.45l.04.57c.02.23.04.43.05.62l1.19-1.19c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-2.86,2.86h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0c-.19.19-.44.28-.7.28Z"
			/>
		</svg>
	</span>
);

const CardIcon = ({ color }: ICardIconProps) => {
	const commonClasses = 'h-8 w-8 rounded-full flex items-center justify-center';

	const colorClass = color === 'red' ? 'bg-red-500' : 'bg-yellow-500';

	return (
		<span className={classNames(commonClasses, colorClass)}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				fill="#ffffff"
				className="w-5 h-5"
			>
				<path d="m16.43,23H7.57c-1.97,0-3.57-1.6-3.57-3.57V4.57c0-1.97,1.6-3.57,3.57-3.57h8.86c1.97,0,3.57,1.6,3.57,3.57v14.86c0,1.97-1.6,3.57-3.57,3.57ZM7.57,3c-.86,0-1.57.7-1.57,1.57v14.86c0,.87.7,1.57,1.57,1.57h8.86c.87,0,1.57-.7,1.57-1.57V4.57c0-.86-.7-1.57-1.57-1.57H7.57Z" />
			</svg>
		</span>
	);
};

const MatchTimeline = ({ combinedEvents, homeId, awayId }: IMatchTimelineProps) => {
	const checkGoalScorerNameBelongsToHomeOrAway = (contestantId: string | undefined) => contestantId === homeId;

	return (
		<div className="relative">
			<div className="absolute left-1/2 transform -translate-x-1/2 h-full border-r-2 border-gray-200"></div>
			<ul role="list" className="-mb-8 space-y-12">
				{combinedEvents.map((event, i) => (
					<li key={i} className="relative flex">
						{/* check if the index is home or away */}

						{checkGoalScorerNameBelongsToHomeOrAway(event.contestantId) ? (
							<>
								<div className="flex justify-end w-1/2 pr-8">
									<div className="relative flex space-x-4 gap-4 bg-kkd-blue-dark p-4 rounded text-white w-full flex-row-reverse ">
										<div className="text-right hidden md:block">
											{event.eventType === 'missedPen' && event.type === 'PM' && (
												<PenaltyIcon color="red" />
											)}
											{event.eventType === 'goal' && event.type === 'PG' && (
												<PenaltyIcon color="green" />
											)}
											{event.eventType === 'goal' &&
												(event.type === 'G' || event.type === 'OG') && (
													<GoalIcon color={`${event.type === 'OG' ? 'red' : 'yellow'}`} />
												)}
											{event.eventType === 'substitute' && <SubstituteIcon />}
											{event.eventType === 'card' && (
												<CardIcon color={`${event.type === 'YC' ? 'yellow' : 'red'}`} />
											)}
										</div>
										<div className="text-right">
											<div>
												{event.eventType === 'missedPen' && event.type === 'PM' && (
													<>
														<h3 className="text-sm lg:text-lg font-bol">
															Gemiste penalty!
														</h3>
														<p className="text-sm lg:text-base leading-snug mt-2">
															{event.playerName}
														</p>
													</>
												)}
												{event.eventType === 'goal' && (
													<>
														<>
															<h3 className="text-sm lg:text-lg font-bold">
																{event.type === 'PG'
																	? 'Penalty gescoord!'
																	: event.type === 'OG'
																	? 'Eigen doelpunt!'
																	: 'Doelpunt!'}
															</h3>
															<p className="text-sm lg:text-base leading-snug mt-2">
																{event.scorerName}
															</p>
														</>
														{event.assistPlayerName && (
															<div className="mt-2">
																<h3 className="text-sm lg:text-lg font-bold">Assist</h3>
																<p className="text-sm lg:text-base leading-snug mt-2">
																	{event.assistPlayerName}
																</p>
															</div>
														)}
													</>
												)}

												{event.eventType === 'substitute' && (
													<>
														<h3 className="text-sm lg:text-lg font-bold">Wissel</h3>
														<p className="text-sm lg:text-base leading-snug mt-2">
															{event.playerOnName} komt erin voor {event.playerOffName}
														</p>
													</>
												)}

												{event.eventType === 'card' && (
													<>
														<h3 className="text-sm lg:text-lg font-bold">{`${
															event.type === 'YC' ? 'Gele kaart' : 'Rode kaart'
														}`}</h3>
														<p className="text-sm lg:text-base leading-snug mt-2">
															{event.playerName}
														</p>
													</>
												)}
											</div>
										</div>
									</div>

									<div className="absolute left-1/2 transform -translate-x-1/2 bg-kkd-blue-dark flex justify-center items-center w-8 h-8 rounded-full">
										<div className="whitespace-nowrap text-xs font-bold text-white">
											{event.timeMin}
											{'"'}
										</div>
									</div>
								</div>
								<div className="w-1/2"></div>
							</>
						) : (
							<>
								{/* Empty space on the left */}
								<div className="w-1/2"></div>
								{/* Right side content */}
								<div className="flex justify-start w-1/2 pl-8">
									<div className="relative flex space-x-4 border bg-kkd-blue-dark p-4 rounded text-white w-full">
										<div className="hidden md:block">
											{event.eventType === 'missedPen' && event.type === 'PM' && (
												<PenaltyIcon color="red" />
											)}
											{event.eventType === 'goal' && event.type === 'PG' && (
												<PenaltyIcon color="green" />
											)}
											{event.eventType === 'goal' &&
												(event.type === 'G' || event.type === 'OG') && (
													<GoalIcon color={`${event.type === 'OG' ? 'red' : 'yellow'}`} />
												)}
											{event.eventType === 'substitute' && <SubstituteIcon />}
											{event.eventType === 'card' && (
												<CardIcon color={`${event.type === 'YC' ? 'yellow' : 'red'}`} />
											)}
										</div>
										<div className="flex min-w-0 flex-1 justify-between space-x-4">
											<div>
												{event.eventType === 'missedPen' && event.type === 'PM' && (
													<>
														<h3 className="text-sm lg:text-lg font-bold">
															Gemiste penalty!
														</h3>
														<p className="text-sm lg:text-base leading-snug mt-2">
															{event.playerName}
														</p>
													</>
												)}
												{event.eventType === 'goal' && (
													<>
														<>
															<h3 className="text-sm lg:text-lg font-bold">
																{event.type === 'PG'
																	? 'Penalty gescoord!'
																	: event.type === 'OG'
																	? 'Eigen doelpunt!'
																	: 'Doelpunt!'}
															</h3>
															<p className="text-sm lg:text-base leading-snug mt-2">
																{event.scorerName}
															</p>
														</>
														{event.assistPlayerName && (
															<div className="mt-2">
																<h3 className="text-sm lg:text-lg font-bold">Assist</h3>
																<p className="text-sm lg:text-base leading-snug mt-2">
																	{event.assistPlayerName}
																</p>
															</div>
														)}
													</>
												)}

												{event.eventType === 'substitute' && (
													<>
														<h3 className="text-sm lg:text-lg font-bold">Wissel</h3>
														<p className="text-sm lg:text-base leading-snug mt-2">
															{event.playerOnName} komt erin voor {event.playerOffName}
														</p>
													</>
												)}

												{event.eventType === 'card' && (
													<>
														<h3 className="text-sm lg:text-lg font-bold">{`${
															event.type === 'YC' ? 'Gele kaart' : 'Rode kaart'
														}`}</h3>
														<p className="text-sm lg:text-base leading-snug mt-2">
															{event.playerName}
														</p>
													</>
												)}
											</div>
										</div>
									</div>

									<div className="absolute left-1/2 transform -translate-x-1/2 bg-kkd-blue-dark flex justify-center items-center w-8 h-8 rounded-full">
										<div className="whitespace-nowrap text-xs font-bold text-white">
											{event.timeMin}
											{'"'}
										</div>
									</div>
								</div>
							</>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};

export default MatchTimeline;
